import * as yup from 'yup'

export const editPasswordSchema = yup.object({
	oldPassword: yup.string().required('Campo obrigatório'),
	password: yup
		.string()
		.required('Campo obrigatório')
		.min(6, 'A senha deve conter pelo menos 8 caracteres'),
	retypePassword: yup
		.string()
		.required('Campo obrigatório')
		.oneOf(
			[yup.ref('password')],
			'Ops! Suas senhas devem ser iguais, tente novamente.'
		),
})

export const editAddresschema = yup.object({
	cep: yup.string().required('Campo obrigatório'),
	address: yup.string().required('Campo obrigatório'),
	number: yup.string().required('Campo obrigatório'),
	district: yup.string().required('Campo obrigatório'),
	city: yup.string().required('Campo obrigatório'),
	state: yup.string().required('Campo obrigatório'),
})

export const editInfochema = yup.object({
	name: yup.string().required('Campo obrigatório'),
	birthdate: yup.date(),
	whatsapp: yup.string(),
	phone: yup.string(),
})

export const editPhonechema = yup.object({
	phone: yup
		.string()
		.required('Insira ao menos seu WhatsApp.')
		.min(10, 'Por favor, insira um número com no mínimo 10 dígitos.'),
})
